import { LocationCardState } from "../reducers";


export function getDynamicSectionByName(state: LocationCardState<unknown>, name: string, mp: 0 | 1, index: 0 | 1) {
    const allLoadedConfigs = state.options.loadedDynamicConfigs;
    const config = allLoadedConfigs.find((v) => v.id.name === name);

    if (!config) {
        return null;
    }

    return config;
}
